import './language.scss';

import { useLocalize } from 'localize-react';
import React, { useContext, useEffect, useState } from 'react';

import { useLocalStorage } from '../../hooks/useLocalStorage';
import { LocalizationContext } from '../localization/Localization';
import { ILanguageOption } from './LanguageContext';

const fetchLanguageOptions = async () => {

  const storyblock = {
    baseUrl: window.tz_globalConfigs?.storyblokURL,
    token: window.tz_globalConfigs?.storyblokToken,
    storyPath: window.tz_globalConfigs?.travellerAppLanguageOptionsStoryPath,
  };

  const queryParams = `token=${storyblock.token}&version=published`;
  let result = null;

  try {
    result = await fetch(`${storyblock.baseUrl}${storyblock.storyPath}?${queryParams}`,
    ).then((res) => res.json());

    if (result?.story?.content) {
      return result.story.content.Options;
    }
  } catch (e) {
    console.log('Error in fetching translations from Storyblock - ', e);
  }
};

export const Language: React.FC = () => {
  const { locale } = useLocalize();
  const { setLocale } = useContext(LocalizationContext);
  const [, setValue] = useLocalStorage('preferredLanguage');
  const [languagesOptions, setLanguages] = useState<string[]>([]);

  useEffect(() => {
    async function getLanguageOptions() {
      if (window?.tz_globalConfigs?.storyblokURL) {
        const storyBloklanguageOptions = await fetchLanguageOptions();
        const storyBlokAvaliableLanguages: string[] = storyBloklanguageOptions?.map((lng: ILanguageOption) => lng.language_iso_code.split('-')[0]);
        setLanguages(storyBlokAvaliableLanguages);
      }
    }
    getLanguageOptions();
  }, []);

  return (
    <div className="language-container">
      <select
        name="language"
        id="language"
        value={locale}
        data-testid="language-dropdown"
        onChange={e => {
          setValue('preferredLanguage', e?.target.value);
          setLocale(e?.target.value);
        }}
      >
        {languagesOptions.map((option: string) => <option key={option} value={option}>{option.toUpperCase()}</option>)}
      </select>
    </div>
  );
};
